export const RELEASE_NOTES = [
  "ANA DEPO: MÜŞTERİLERİ İLE GÖRE VEYA SEÇİLİ FİRMALARA TOPLU AKTARMA",
  "AKTARMA GEÇMİŞİ: MÜŞTERİLER SAYFASI VE AYARLAR'DA",
  "GRUP BAZLI VARSAYILAN MENÜ",
  "MÜŞTERİLER SAYFASINDA ÜSTTE FİRMA ARAMA (TÜM KAYITLARDA ARAR)",
  "MESAJLAR: ONLINE KİŞİLER, DARALT/KAPAT, GÖRÜLDÜ / OKUNDU",
  "HARİTA: STANDART VEYA DİJİTAL İL HARİTASI (KİŞİYE ÖZEL KAYITLI)",
  "GÖSTERGE PANELİ: TEK EKRAN, KUTU EKLE / TAŞI / BOYUTLANDIR",
  "AYARLAR: TEK SATIR BAŞLIKLAR, SADE GÖRÜNÜM",
  "MÜŞTERİ HARİTASI: ADRESE GÖRE GERÇEK KONUM",
  "ANA DEPO AMBARLARI TÜM FİRMALARDA ORTAK GÖRÜNÜR",
  "MESAJLAR SAĞ ALTTA; GRUP FİRMALARI BİRBİRİNE YAZABİLİR",
  "TÜMÜNÜ SİL: FİRMA PIN İLE, AYARLAR > GÜVENLİK'TE",
  "HIZLI FİRMA EKLE ÜST İŞLEMLERDE; MENÜDEN ÜSTE TAŞIMA",
  "PARA GÖSTERİMİ HER YERDE 10.000,50 (TL YOK)",
  "YENİ RAPORLAR: MÜŞTERİ, KARGO, TAHSİLAT, ARAÇ · TARİH ARALIKLI",
  "TAKİP NO OTOMATİK (000001…), ATF NO + ŞUBE ZİMMETİ, MÜŞTERİ İRSALİYE NO",
  "PARAŞÜT: KARGO OTOMATİK TASLAK FATURA, SENKRONİZE, PARAŞÜT İNCELE",
  "FİRMA YÖNETİMİ: FİRMAYA TIKLA → KULLANICI/YETKİ/AYAR YÖNET",
  "KARGO GİRİŞİ YENİLENDİ: ⚡ KAŞE/GÖRSEL/YAZI İLE MÜŞTERİ, ÇOK SATIRLI KALEM, OTOMATİK DESİ/KDV",
];
